import parseDestinationExtra from '@anm/helpers/stream/parseDestinationExtra';
import { SocialDestination } from 'types/stream';

export const isDestinationEnabled = (destination: SocialDestination) =>
  destination.network === 'LINKEDIN'
    ? !!parseDestinationExtra(destination)['allowed']
    : destination.network === 'YOUTUBE'
    ? parseDestinationExtra(destination)['status'] === 'allowed'
    : destination.enabled;
